import PreauthRoutes from 'src/app/preauth/preauth-routing'
import DashboardRoutes from 'src/app/dashboard/dashboard-routing'

export default [
    PreauthRoutes,
    DashboardRoutes
]